import React from 'react';
import RouterLink from 'components/RouterLink';

interface LoginFooterProps {
  showWelcomeBack: boolean;
  search: string;
}

const LoginFooter = ({ showWelcomeBack, search }: LoginFooterProps) => (
  <>
    <div>
      <RouterLink title="Reset your password" href="/reset-password" className="link--danger">
        Forgot password
      </RouterLink>
    </div>
    {!showWelcomeBack && (
      <div>
        <RouterLink title="Register with us" href={`/signup/account-details${search}`}>
          Not a player? Sign up now
        </RouterLink>
      </div>
    )}
  </>
);

export default LoginFooter;
